import store from "../Redux/Store";

export const isOwner = () => {
  const storeData = store.getState().storeReducer?.store;
  return storeData?.owner?.role === "owner";
};
